import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Product } from '@mare-common/ngx-delfi-components/lib/products-list/product.interface';

export interface ProductRelatedItem {
  sku: string;
  name: string;
  description?: string;
  icon?: string;
  image?: string;
  suggestion?: {
    title: string;
    description: string;
    solution: string;
  }
}
@Component({
  selector: 'product-related-item',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    NgOptimizedImage
  ],
  templateUrl: './product-related-item.component.html',
  styleUrls: ['./product-related-item.component.scss']
})
export class ProductRelatedItemComponent implements OnInit {
 
  /**
   * item as ProductRelatedItem interface
   */
  @Input() item!: ProductRelatedItem

  /**
   * layout as 'carousel' | 'grid' | 'accordion' | 'list'
   * */
  @Input() layout: 'carousel'| 'card' | 'list' = 'carousel'
  
  @Output() clickedItem: EventEmitter<ProductRelatedItem> = new EventEmitter();
  
  ngOnInit(): void {
    console.log(this.item)
  }

  click_event() {
    this.clickedItem.emit(this.item);
  }
}
